import { colors } from 'style/config';
import {
    Flex, Grid, Icon, Text
} from 'components/ui';
import OOSAlternateLinkBindings from '../../../../analytics/bindingMethods/components/rwdBasket/OOSAlternateLinkBindings';
import { wrapFunctionalComponent } from 'utils/framework';

function TopOfBasketErrors({ topOfBasketErrors, oosBiOrSample }) {
    if (!topOfBasketErrors.isAvailable) {
        return null;
    }

    const { isBiOOS, isSampleOOS, isGwpOOS } = oosBiOrSample;

    if (isBiOOS) {
        OOSAlternateLinkBindings.trackErrorMessageAnalytics({ fieldName: 'bi-reward', errorMessage: topOfBasketErrors.messages[0], oosBiOrSample });
    }

    if (isSampleOOS) {
        OOSAlternateLinkBindings.trackErrorMessageAnalytics({
            fieldName: 'smart sample',
            errorMessage: topOfBasketErrors.messages[0],
            oosBiOrSample
        });
    }

    if (isGwpOOS) {
        OOSAlternateLinkBindings.trackErrorMessageAnalytics({
            fieldName: 'gwp-reward',
            errorMessage: topOfBasketErrors.messages[0],
            oosBiOrSample
        });
    }

    return (
        <Grid
            gap={2}
            minWidth={'100%'}
        >
            {topOfBasketErrors.messages.map((message, i) => (
                <Flex
                    key={`errorMessage_${i}`}
                    gap={4}
                    alignItems={'flex-start'}
                    backgroundColor={colors.lightRed}
                    color={colors.red}
                    borderRadius={2}
                    padding={3}
                    lineHeight='tight'
                    data-at={Sephora.debug.dataAt(i > 0 ? `items_error_message_${i + 1}` : 'items_error_message')}
                >
                    <Icon
                        size={16}
                        name={'alert'}
                    />
                    <Text
                        fontSize={'base'}
                        display={'inline-block'}
                    >
                        {message}
                    </Text>
                </Flex>
            ))}
        </Grid>
    );
}

export default wrapFunctionalComponent(TopOfBasketErrors, 'TopOfBasketErrors');
